import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import { Base } from '../../Base';
import { Hide, SrOnly } from '../../Helper';
import Svg from '../../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Step-root_1SfKo",
  "index": "Step-index_3MrxN",
  "icon": "Step-icon_1DtZR",
  "disabled": "Step-disabled_Zg8XZ",
  "completed": "Step-completed_KgK7t",
  "active": "Step-active_34lRg",
  "error": "Step-error_1ryR2"
};
function Index({
  status,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: "span",
    flex: true,
    flexAlignItemsCenter: true,
    flexJustifyCenter: true,
    flexShrink0: true,
    className: styles.index,
    ...extraProps
  });
}
function Root({
  index,
  status = 'disabled',
  className,
  ...extraProps
}) {
  const rootClasses = clsx(styles.root, {
    [styles.disabled]: status === 'disabled',
    [styles.active]: status === 'active',
    [styles.completed]: status === 'completed',
    [styles.error]: status === 'error'
  }, className);
  return /*#__PURE__*/_jsx(Base, {
    tagName: "li",
    flex: true,
    flexGrow1: true,
    flexAlignItemsCenter: true,
    className: rootClasses,
    ...extraProps
  });
}
function Step(props) {
  const {
    status = 'disabled',
    children,
    index
  } = props;
  const {
    __
  } = useTranslator();
  if (status === 'completed') {
    return /*#__PURE__*/_jsx(Hide, {
      until: "md",
      component: /*#__PURE__*/_jsxs(Root, {
        ...props,
        children: [/*#__PURE__*/_jsx(Index, {
          status: status,
          children: /*#__PURE__*/_jsx(Svg, {
            name: "miniCheckmark",
            size: "3x",
            className: styles.icon
          })
        }), /*#__PURE__*/_jsx(SrOnly, {
          children: __('Completed: ')
        }), children]
      })
    });
  }
  if (status === 'error') {
    return /*#__PURE__*/_jsxs(Root, {
      ...props,
      children: [/*#__PURE__*/_jsx(Index, {
        status: status,
        children: /*#__PURE__*/_jsx(Svg, {
          name: "miniCrossBold",
          size: "3x",
          className: styles.icon
        })
      }), /*#__PURE__*/_jsx(SrOnly, {
        children: __('Error: ')
      }), children]
    });
  }
  if (status === 'active') {
    return /*#__PURE__*/_jsxs(Root, {
      ...props,
      children: [/*#__PURE__*/_jsx(Index, {
        status: status,
        children: index
      }), /*#__PURE__*/_jsx(SrOnly, {
        children: __('Active: ')
      }), children]
    });
  }
  return /*#__PURE__*/_jsx(Hide, {
    until: "md",
    component: /*#__PURE__*/_jsxs(Root, {
      ...props,
      children: [/*#__PURE__*/_jsx(Index, {
        status: status,
        children: index
      }), children]
    })
  });
}
export default Step;